<template>
    <div class="orderNo">
        <div style="color:#1E3C3E;margin-right:0.2rem">{{orderNo}}</div>
        <van-image  width="20" height="20" :src="require('@/assets/order/copy.png')" @click.stop="handleCopy"/>
    </div>
</template>
<script>
import { Toast } from 'vant';
export default {
    name:'OrderNo',
    props:{
        orderNo:{
            type:String,
            default:''
        }
    },
    methods:{
        handleCopy() {
            this.$copyText(this.orderNo).then(
                () => {
                    Toast.success('Copied successfully')
                },
                () => {
                }
            )
        }
    }
}
</script>
<style lang="scss" scoped>
    .orderNo{
        display: flex;
        align-items: center;
    }
</style>
